// removed by extract-text-webpack-plugin
module.exports = {"large":"1600px","desktop":"1366px","ipad":"1024px","ipad-portrait":"768px","mobile-s":"320px","white":"#ffffff","purple":"#7c4d9e","dark-purple":"#4a2e5e","light-purple":"#a096c8","red":"#e40000","dark-red":"#a30000","dark-green":"#008300","background-grey":"#f6f6f6","wrapper":"_3Do2TXaoj8MUBqZ8amWPPB","container":"_3Q0R208RZkCoOFB0YcFXgM","title":"_1zNGHqtK8M7lmUYLKVt3Z","highlight":"_2XtGgwwQALGDp7Ymt6CIBT","description":"_6x_s6Kv-5XDPP0EHkDi9b","link":"_3WJ9uukdxnCDTyFwjUGe9x","image":"_1xqMf6kUeC7F5dblNABQ8c"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Hotspots/Landing/HotspotD/HotspotD.css
// module id = 1470
// module chunks = 0